import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';


@Component({
  selector: 'app-gelios-field-error',
  templateUrl: './gelios-field-error.component.html'
})
export class GeliosFieldErrorComponent implements OnInit {
  @Input() fieldName: string = null;
  @Input() formGroup: FormGroup;
  @Input() messages: {[message: string]: string} = {
    required: 'Required field',
    float: 'Field must be a real number',
    integer: 'The number must be an integer',
    numberGreaterThanZero: 'The number must be greater than 0',
    numberNotLessThanZero: 'The number must not be less than 0',
    numberNotGreaterThanValidator: 'The number must not exceed the limit',
    unsignedFloat: 'Field value must be non-negative number',
    email: 'Invalid e-mail address',
    mustMatch: 'Fields must match',
    pattern: 'Invalid value',
    smsTemplateMustContainCodePlaceholder: 'Sms template must include [[code]] placeholder',
    maxBytesImg: 'Image size is too large',
    maxSizeWidthImg: 'Maximum icon width',
    maxSizeHeightImg: 'Maximum icon height',
    square_meter_rooms: 'Value should be like 12+13+14',
    flatYearValidator: 'Invalid year of construction',
    hwModelSlashValidator: 'Name can only contain letters, numbers, dashes and underscores',
    userListCharacters: 'Login can only contain letters, numbers, dashes and underscores',
    invalidCommandText: 'Command text can only contain latin letters, numbers, punctuation signs',
    percent: 'Value must be between 0 and 100',
    invalidOnlyOneDefaultText: 'Select one default condition',
    invalidPeriod: 'Subscription period already selected',
    atLeastTwoItems: 'At least two items must be selected',
    atLeastOneFieldMustBeFilled: 'At least one field must be filled in',
    atLeastOneFieldMustBeSelected: 'At least one option must be selected',
    userListWhiteSpace: 'Login can\'t contain a whitespace',
    hwModelOnlySymbolValidator: 'Name can\'t start with dash or underscore characters',
    unitTypeName: 'Unit type name may only contain lowercase latin letters, hyphens and underscores',
    timeWithTime: 'Value time is not correct',
    timeLessThan3600: 'Time must be 3600 seconds or more',
    timeLessThan1800: 'Time must be 1800 seconds or more',
    valueIsTooSmall: 'Value is too small',
    invalidTimeInterval: 'Time interval is incorrect',
    invalidFormat: 'Image format must be SVG or PNG',
    imageFormatSvg: 'Image format must be SVG',
    reversedTimeInterval: 'Interval start time must be less than end time',
    atLeastOneNotificationTypeIsRequired: 'At least one notification type must be selected',
    atLeastOneElementIsRequired: 'At least one element must be added',
    atLeastOneLanguageIsRequired: 'Choose at least one language',
    onlyOneField: 'Select one option',
    onlyOneConditions: 'This subscription can have only one condition',
    passwordValidator: 'The value must be at least 6 characters.',
    cannotCombineTheseNotificationConditions: 'These condition types cannot be combined',
    invalidPromoCode: 'Invalid characters in promo code',
    invalidRegistrationNumber: 'Invalid characters in registration number',
    identifier: 'The maximum length of the identifier is 100 characters. ' +
      'Only lowercase Latin letters (a-z), numbers, hyphens and underscores are allowed',
    startsWithPlus: 'Please enter your phone number in international format: start with "+" and include the country code.',
  };
  public field: AbstractControl;
  public messageKeys: Array<string>;
  public ngOnInit() {
    this.messageKeys = Object.keys(this.messages);
    this.field = this.fieldName ? this.formGroup.controls[this.fieldName] : this.formGroup;
  }
}
